const galleryImages = {
	'kb1': '/pictures/gallery/gallery1.JPG',
	'kb2': '/pictures/gallery/gallery2.JPG',
	'kb3': '/pictures/gallery/gallery3.JPG',
	'kb4': '/pictures/gallery/gallery4.JPG',
    'kb5': '/pictures/gallery/gallery5.JPG',
	'kb6': '/pictures/gallery/gallery6.JPG',
	'kb7': '/pictures/gallery/gallery7.JPG',
	'kb8': '/pictures/gallery/gallery8.JPG',
	'kb9': '/pictures/gallery/gallery9.JPG',
    'kb10': '/pictures/gallery/gallery10.JPG',
    'kb11': '/pictures/gallery/gallery11.JPG',
    'kb12': '/pictures/gallery/gallery12.JPG',
    'kb13': '/pictures/gallery/gallery13.JPG',
    'kb14': '/pictures/gallery/gallery14.JPG',
    'kb15': '/pictures/gallery/gallery15.JPG',
	'kb16': '/pictures/gallery/gallery16.JPG',			
};

// Map each keyboardId to a featured buildId for the gallery
export const featuredBuildByKeyboard = {
	// Example: 'kb1': 'b1',
	// Add your mappings here, one per keyboard
	'kb1': 'b39',
	'kb2': 'b48',
	'kb3': 'b29',
	'kb4': 'b3',
	'kb5': 'b14',
	'kb6': 'b6',
	'kb7': 'b18',
	'kb8': 'b22',
	'kb9': 'b54',
	'kb10': 'b2',
	'kb11': 'b13',
	'kb12': 'b11',
	'kb13': 'b42',
	'kb14': 'b1',
	'kb15': 'b31',
	'kb16': 'b24',
};


export const galleryList = [
	'kb10',
	'kb16',
	'kb7',
	'kb6',
	'kb13',
	'kb3',
	'kb1',
	'kb9',
	'kb11',
	'kb8',
	'kb14',
	'kb15',
	'kb2',
	'kb12',
	'kb5',
	'kb4',
	
	
]
export default galleryImages;
